/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }

  updateRole({ inboxId, userId, role, autoAssign }) {
    const params = {
      inbox_id: inboxId,
      user_id: userId,
    };
    if (role !== undefined) params.role = role;
    if (autoAssign !== undefined) params.auto_assign = autoAssign;
    return axios.patch(`${this.url}/update_role`, params);
  }
}

export default new InboxMembers();
